// extracted by mini-css-extract-plugin
export var cartContainer = "_gs-4";
export var gray = "_gs-1";
export var itemContainer = "_gs-2";
export var itemDetails = "_gs-3";
export var strong = "_gs-0";